import React from 'react';

import { SVGComponentProps } from './svg.types';

const CommentAltSVG = ({
  fill = 'currentColor',
  size = '1em',
  wrapperClass,
  ...otherProps
}: SVGComponentProps) => {
  return (
    <span className={`inline-block ${wrapperClass || ''}`}>
      <svg
        width={size}
        height={size}
        viewBox="0 0 16 16"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...otherProps}
      >
        <path
          d="M6.66732 2H9.33398C12.2795 2 14.6673 4.38781 14.6673 7.33333C14.6673 10.2789 12.2795 12.6667 9.33398 12.6667V15C6.00065 13.6667 1.33398 11.6667 1.33398 7.33333C1.33398 4.38781 3.7218 2 6.66732 2ZM8.00065 11.3333H9.33398C11.5431 11.3333 13.334 9.54247 13.334 7.33333C13.334 5.12419 11.5431 3.33333 9.33398 3.33333H6.66732C4.45818 3.33333 2.66732 5.12419 2.66732 7.33333C2.66732 9.74 4.3087 11.3104 8.00065 12.9865V11.3333Z"
          fill={fill}
        />
      </svg>
    </span>
  );
};

export default CommentAltSVG;
